var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 16,
    viewBox: "0 0 27 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.875 2.25H1.125C0.826875 2.24921 0.541187 2.13043 0.330379 1.91962C0.119572 1.70881 0.000791837 1.42313 0 1.125C0.000791837 0.826875 0.119572 0.541187 0.330379 0.330379C0.541187 0.119572 0.826875 0.000791837 1.125 0H25.875C26.1731 0.000791837 26.4588 0.119572 26.6696 0.330379C26.8804 0.541187 26.9992 0.826875 27 1.125C26.9992 1.42313 26.8804 1.70881 26.6696 1.91962C26.4588 2.13043 26.1731 2.24921 25.875 2.25Z",
    fill: "#3ACCE1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.875 9H1.125C0.826875 8.99921 0.541187 8.88043 0.330379 8.66962C0.119572 8.45881 0.000791837 8.17313 0 7.875C0.000791837 7.57687 0.119572 7.29119 0.330379 7.08038C0.541187 6.86957 0.826875 6.75079 1.125 6.75H25.875C26.1731 6.75079 26.4588 6.86957 26.6696 7.08038C26.8804 7.29119 26.9992 7.57687 27 7.875C26.9992 8.17313 26.8804 8.45881 26.6696 8.66962C26.4588 8.88043 26.1731 8.99921 25.875 9Z",
    fill: "#3ACCE1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.875 15.75H1.125C0.826875 15.7492 0.541187 15.6304 0.330379 15.4196C0.119572 15.2088 0.000791837 14.9231 0 14.625C0.000791837 14.3269 0.119572 14.0412 0.330379 13.8304C0.541187 13.6196 0.826875 13.5008 1.125 13.5H25.875C26.1731 13.5008 26.4588 13.6196 26.6696 13.8304C26.8804 14.0412 26.9992 14.3269 27 14.625C26.9992 14.9231 26.8804 15.2088 26.6696 15.4196C26.4588 15.6304 26.1731 15.7492 25.875 15.75Z",
    fill: "#3ACCE1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu_icon.e20d0a2fbbe232a6806b21407cea459a.svg";
export { ForwardRef as ReactComponent };